import { render, staticRenderFns } from "./JCSBInstallation.vue?vue&type=template&id=0be3be84&scoped=true&"
import script from "./JCSBInstallation.vue?vue&type=script&lang=js&"
export * from "./JCSBInstallation.vue?vue&type=script&lang=js&"
import style0 from "./JCSBInstallation.vue?vue&type=style&index=0&id=0be3be84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be3be84",
  null
  
)

export default component.exports